import React from 'react';
import {injectIntl} from 'react-intl';
import DistancePin from "@Components/DistancePin";
import {pushBranchPageVisited} from 'dataLayerHelper';

function BranchListItem({intl, branchData, distance, appConfigs}) {
  const specs = branchData.name || [];


  const Specs = ({specs}) => {
    if (specs.length > 0) {
      return (
          <div className="list-item__description text--alternative">
            <ul>
              {specs.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>
      )
    } else {
      return null
    }
  };

  const branchListItemClick = () => {
      pushBranchPageVisited();
  }

  return (
      <li className="list-item divider">
        <div className="list-item__info">
          <div className="list-item__title">
            <h2 className="list-item__header">
              <a className="list-item__link" href={branchData.url}>{branchData.title}</a>
            </h2>
          </div>
          <DistancePin distance={distance} appConfigs={appConfigs}/>
          <ul className="list-item__meta">
            <li>{branchData.address_line1}</li>
            <li>{branchData.address_line2}</li>
            <li>{ (branchData.postal_code || '') + ' ' + (branchData.locality || '')}</li>
            <li>
              <a href={`tel:${branchData.field_phone}`}>
                {branchData.field_phone}
              </a>
            </li>
          </ul>
          <Specs specs={specs} />
        </div>
        <a className="list-item__button button button--m"  onClick={branchListItemClick} href={branchData.url[0]}>
          { intl.formatMessage({id: "BranchListItem.MoreInfoLabel"}) }
        </a>
      </li>
  );
}

export default injectIntl(BranchListItem);
